<div class="py-4 flex flex-wrap gap-4">
  @for (pair of energyStatPairs(); track $index) {
    <div class="flex-grow basis-[calc(50%-1rem)] flex-wrap flex gap-4">
      @for (item of pair; track item.name) {
        <avs-energy-value
          class="flex-grow basis-[calc(50%-0.5rem)] min-w-[150px]"
          [config]="{
            showFullTitle: false,
            type: item.name,
            value: item.value
          }"
        />
      }
    </div>
  }
</div>
